import { FC, ReactNode } from 'react';
import { FosforStikstof } from './fosfor_stikstof';
import { useHeeftLozing } from './use-heeft-lozing';

interface ComponentWithTeeltwijze {
  teeltwijze: number;
}

interface Properties {
  teeltwijze: number;
  renderZuiveringswijze: () => ReactNode;
  LozingsvormComponent: FC<ComponentWithTeeltwijze>;
  LozingenComponent: FC<ComponentWithTeeltwijze>;
  MetingenComponent: FC<ComponentWithTeeltwijze>;
  showFosforStikstof?: boolean;
  alwaysShowMetingen?: boolean;
}

export const MilieugegevensFlow: FC<Properties> = ({
  teeltwijze,
  renderZuiveringswijze,
  LozingsvormComponent,
  LozingenComponent,
  MetingenComponent,
  showFosforStikstof = false,
  alwaysShowMetingen = false,
}) => {
  const heeftLozing = useHeeftLozing(teeltwijze);
  const showMetingen = alwaysShowMetingen || heeftLozing;

  return (
    <>
      {renderZuiveringswijze()}
      {showFosforStikstof && <FosforStikstof />}
      <LozingsvormComponent teeltwijze={teeltwijze} />
      {heeftLozing && <LozingenComponent teeltwijze={teeltwijze} />}
      {showMetingen && <MetingenComponent teeltwijze={teeltwijze} />}
    </>
  );
};
